
import selectOption from '@/store/dict/selectOptionDict'
import { getbatchCollectionRecordList } from '@/api/domain/returnLease'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  return {
    configData: {
      formData: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '收款状态',
              prop: 'state',
            },
            elConfig: {
              options: { // 下拉数据
                label: 'label',
                value: 'value',
                list: this.dictParseList(selectOption.batchStateDict),
              },
            },
          },
        ],
        dealWithSearch: this.dealWithSearch,
      },
      tableData: {
        columns: [
          {
            name: 'id',
            columnProps: {
              label: '收款ID',
              prop: 'id',
              width: 120,
            },
          },
          {
            name: 'amount',
            columnProps: {
              label: '收款金额（元）',
              prop: 'amount',
              width: 120,
            },
          },
          {
            name: 'receivableAccountName',
            columnProps: {
              label: '收款账户',
              prop: 'receivableAccountName',
            },
          },
          {
            name: 'customerType',
            columnProps: {
              label: '付款方类型',
              prop: 'customerType',
              width: 110,
            },
            getText: ({ row }) => selectOption.customerTypeDict[row.customerType],
          },
          {
            name: 'customerName',
            columnProps: {
              label: '付款方',
              prop: 'customerName',
              width: 160,
            },
          },
          {
            name: 'paymentAccount',
            columnProps: {
              label: '客户付款账户',
              prop: 'paymentAccount',
              width: 120,
            },
          },
          {
            name: 'state',
            columnProps: {
              label: '收款状态',
              prop: 'state',
            },
            getText: ({ row }) => selectOption.batchStateDict[row.state],
          },
          {
            name: 'gmtCreate',
            columnProps: {
              label: '创建时间',
              prop: 'gmtCreate',
              width: 158,
            },
          },
          {
            name: 'completeTime',
            columnProps: {
              label: '完成时间',
              prop: 'completeTime',
              width: 158,
            },
          },
          {
            name: 'discardTime',
            columnProps: {
              label: '作废时间',
              prop: 'discardTime',
              width: 158,
            },
          },
          {
            name: 'discardDesc',
            columnProps: {
              label: '作废原因',
              prop: 'discardDesc',
              width: 158,
            },
          },
          {
            name: 'operate',
            columnProps: {
              label: '操作',
              fixed: 'right',
              width: 240,
            },
            maxShowLength: operateMaxShowLength,
            type: 'operate',
            getOperateList: ({ row }) => {
              const result = []
              // 详情按钮
              const detailBtn = {
                name: 'viewDetail',
                label: '详情',
                action: () => this.viewDetail(row),
              }
              if (this.judgePermission('finance_batch_receivable_record_detail')) {
                result.push(detailBtn)
              }
              return result
            },
          },
        ],
        apiFn: getbatchCollectionRecordList,
      },
      isShowDepartment: false,
    },
  }
}
